<template>
  <div class="manage-change-container">
    <div class="manage-change-body">
      <div class="content">
        <el-form
          v-if="!isFinish"
          class="custom-success-input"
          ref="meanageChangeForm"
          :model="form"
          :rules='formRules'
          label-width="90px"
          :label-position="labelPosition"
          @submit.native.prevent
        >
          <el-form-item :label="step === 1 ? '手机号码' : '用户手机号'" prop="phone">
            <el-input v-model="form.phone" AUTOCOMPLETE="off" :disabled="step === 1" @input="updateState"></el-input>
          </el-form-item>
          <el-form-item label="图片验证" :error="errors.imgCodeError">
            <el-row>
              <el-col :span="14">
                <el-input v-model="form.imageCode" AUTOCOMPLETE="off" @input="updateState" @blur="clearErrorState"></el-input>
              </el-col>
              <el-col class="text-right" :span="10">
                <div class="verify-img">
                  <img @click.stop="changeCode" alt="点击更换" title="点击更换" :src="form.imageSrc">
                </div>
              </el-col>
            </el-row>
          </el-form-item>
          <el-form-item label="手机验证码">
            <el-row>
              <el-col :span="14">
                <el-input v-model="form.phoneCode" AUTOCOMPLETE="off" @input="updateState"></el-input>
              </el-col>
              <el-col class="text-right" :span="10">
                <el-button type="primary" @click="getPhoneCode" :disabled="isGetPhoneCode">{{ (time === 60) ? '' : time }}{{ phoneHint }}</el-button>
                <input class="hidden-input" type="text">
              </el-col>
            </el-row>
          </el-form-item>
          <el-form-item v-if="step === 1" label="密码">
            <input class="hidden-input" type="password">
            <el-input type="password" AUTOCOMPLETE="off" v-model="form.password" @input="updateState"></el-input>
          </el-form-item>
          <el-form-item class="text-center next-step">
            <el-button type="primary" @click="next" :disabled="canNext">下一步</el-button>
          </el-form-item>
        </el-form>
        <div v-else class="finish text-center">
          <div class="img">
            <img src="../assets/finish.png">
          </div>
          <p>设置成功！</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'manageChange',
  data () {
    let isPhone = (rule, value, callback) => {
      if (value.replace(/(^\s*)|(\s*$)/g, '') !== '') {
        if (!(/^1[3-9]\d{9}$/.test(value))) {
          return callback(new Error('请输入正确手机号'))
        } else {
          callback()
        }
      } else {
        return callback(new Error('请输入手机号'))
      }
    }
    return {
      labelPosition: 'left',
      form: {
        phone: '',
        imageSrc: '',
        imageCode: '',
        phoneCode: '',
        password: ''
      },
      // 步骤
      step: 1,
      // 是否完成更改
      isFinish: false,
      isGetPhoneCode: true,
      phoneHint: '获取验证码',
      time: 60,
      isGaining: false,
      canNext: true,
      errors: {
        imgCodeError: ''
      },
      formRules: {
        phone: [{ validator: isPhone, trigger: 'blur' }]
      },
      phoneCode: '',
      timer: null
    }
  },
  methods: {
    // 点击更换验证码
    changeCode () {
      this.form.imageSrc =
        `/auth-api/verificationCode.jpg?t=` + new Date().getTime()
    },
    // 下一步
    next () {
      this.$nextTick(() => {
        switch (this.step) {
        // 验证管理员身份
          case 1 : this.verifyManage()
            break
          case 2 : this.updateManage()
            break
        }
      })
    },
    // 获取当前用户的手机号
    getPhone () {
      this.$axios.get('/auth-api/admin').then(res => {
        this.form.phone = res.data.phone
      })
    },
    // 获取手机验证码
    getPhoneCode () {
      this.errors.imgCodeError = ''
      this.$nextTick(() => {
        this.$refs.meanageChangeForm.validateField('phone', validate => {
          if (!validate) {
            this.$axios.get(`/auth-api/admin/getTelCode?imgCode=${this.form.imageCode}&phone=${this.form.phone}`).then(res => {
              this.time -= 1
              this.phoneHint = `s后重新获取`
              this.isGetPhoneCode = true
              this.isGaining = true
              this.timer = setInterval(() => {
                this.time -= 1
                if (this.time === 0) {
                  clearInterval(this.timer)
                  if (this.form.imageCode.replace(/(^\s*)|(\s*$)/g, '') !== '') {
                    this.isGetPhoneCode = false
                  } else {
                    this.isGetPhoneCode = true
                  }
                  this.phoneHint = '获取验证码'
                  this.time = 60
                  this.isGaining = false
                }
              }, 1000)
            }).catch(() => {
              this.changeCode()
              this.step = 1
            })
          }
        })
      })
    },
    // 验证管理员身份
    verifyManage () {
      let parmas = {
        imageCode: this.form.imageCode,
        phone: this.form.phone,
        password: this.form.password,
        phoneCode: this.form.phoneCode
      }
      this.$axios.post('/auth-api/admin/checkAdmin', parmas).then(res => {
        if (res.data) {
          this.step = 2
          this.clearInput()
        }
      })
    },
    // 更改管理员
    updateManage () {
      let parmas = {
        imageCode: this.form.imageCode,
        phone: this.form.phone,
        phoneCode: this.form.phoneCode
      }
      this.$axios.post('/auth-api/admin/changeAdmin', parmas).then(res => {
        if (res.data) {
          this.step = 1
          this.isFinish = true
        }
      })
    },
    updateState () {
      // 如果不是正在获取验证码
      let imgCode = this.form.imageCode.replace(/(^\s*)|(\s*$)/g, '')
      let phoneCode = this.form.phoneCode.replace(/(^\s*)|(\s*$)/g, '')
      let password = this.form.password.replace(/(^\s*)|(\s*$)/g, '')
      let phone = this.form.phone.replace(/(^\s*)|(\s*$)/g, '')
      if (!this.isGaining) {
        if (this.step === 1) {
          if (imgCode !== '') {
            this.isGetPhoneCode = false
          } else {
            this.isGetPhoneCode = true
          }
        } else {
          if (imgCode !== '' && phone !== '') {
            this.isGetPhoneCode = false
          } else {
            this.isGetPhoneCode = true
          }
        }
      }
      if (this.step === 1) {
        if (phoneCode !== '' && password !== '' && imgCode !== '') {
          this.canNext = false
        } else {
          this.canNext = true
        }
      } else if (this.step === 2) {
        if (phoneCode !== '' && phone !== '' && imgCode !== '') {
          this.canNext = false
        } else {
          this.canNext = true
        }
      }
    },
    clearInput () {
      this.$refs.meanageChangeForm.resetFields()
      this.isGetPhoneCode = true
      this.canNext = true
      this.time = 60
      this.isGaining = false
      this.phoneHint = '获取验证码'
      this.errors.imgCodeError = ''
      this.form.phone = ''
      this.form.imageSrc = ''
      this.form.imageCode = ''
      this.form.phoneCode = ''
      this.form.password = ''
      clearInterval(this.timer)
      this.changeCode()
    },
    clearErrorState () {
      this.errors.imgCodeError = ''
    }
  },
  created () {
    this.changeCode()
    this.getPhone()
  }
}
</script>

<style lang="scss">
  .manage-change-container {
    padding: 10px;
    height: 100%;

    .manage-change-body {
      background: #fff;
      box-shadow: 0px 3px 9px 0px rgba(179, 196, 208, 0.2);
      border-radius: 4px 0;
      height: 100%;

      .hidden-input {
        position: absolute;
        z-index: -999;
        left: 0;
        height: 1px;
        width: 1px;
      }

      .el-form-item__label {
        color: #232323;
        font-size: 12px;
      }

      .text-right {
        text-align: right;
      }

      .text-center {
        text-align: center;
      }

      .content {
        width: 370px;
        margin: 0 auto;
        padding-top: 116px;

        .verify-img {
          display: inline-block;
          width: 102px;
          height: 30px;
          border-radius: 4px;
          background-color: #e3e2f0;
          vertical-align: middle;
          cursor: pointer;

          img {
            border-radius: 5px;
            height: 100%;
            width: 100%;
          }
        }

        .next-step {
          padding-top: 20px;

          .el-button {
            padding: 8px 22px;
          }
        }

        .finish {
          .img {
            padding-top: 116px;
          }

          p {
            padding: 39px 0 53px 0;
          }
        }
      }
    }
  }
  @import "@/assets/scss/common.scss";
</style>



// WEBPACK FOOTER //
// src/components/system/system/manage-change.vue